import { css } from "@emotion/css";
import styled from "@emotion/styled";
import {
    BorderRadius,
    Colors,
    FontSizeInPx,
    FontWeight,
    LineHeightInPx,
    ShadowValue,
    Spacing,
} from "@snapchat/snap-design-system";

import { fontFamily } from "./font.styles";
import { truncate } from "./truncate.styles";

export const popoverStyle = css`
    & .ant-popover-arrow {
        display: none;
    }

    & .ant-popover-inner {
        border-radius: ${BorderRadius.container}px;
    }

    & .ant-popover-inner-content {
        padding: 0;
    }
`;

export const popoverStyleWithPadding = css`
    & .ant-popover-arrow {
        display: none;
    }

    & .ant-popover-inner {
        border-radius: ${BorderRadius.container}px;
    }
`;

export const PopoverContent = styled.div`
    cursor: pointer;

    display: flex;

    min-width: 180px;
    height: 28px;
    padding: ${Spacing["1XS"]}px ${Spacing.SM}px;

    background: ${Colors.WHITE};
    border-radius: ${BorderRadius.container}px;
    box-shadow: ${ShadowValue.regular};
`;

export const TextContainer = styled.div`
    display: flex;
    align-items: center;

    min-width: 136px;
    max-width: 280px;

    font-size: ${FontSizeInPx.COMPACT}px;
    font-weight: ${FontWeight.NORMAL};
    color: ${Colors.Black.V100};
    ${truncate};
`;

export const chevronIcon = css`
    margin-left: ${Spacing.XS}px;
`;

export const chevronIconFlipped = css`
    transform: rotateX(180deg);
`;

export const TextWrapper = styled.div`
    overflow-x: hidden;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const searchBarHeight = LineHeightInPx.REGULAR + Spacing.SM * 2;

export const SearchableListSizeConfig = {
    height: 300,
    width: 300,
    lensHeight: 48,
};

export const SearchableListContainer = styled.div<{ width: number; height: number }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    width: ${({ width }) => width + Spacing.MD * 2}px;
    height: ${({ height }) => height + searchBarHeight + Spacing.XS + Spacing.MD}px;

    border-radius: ${BorderRadius.container}px;
    box-shadow: ${ShadowValue.elevated};

    > .sds-card {
        width: 100%;
        margin: 0;
        padding: ${Spacing.MD}px ${Spacing.XS}px ${Spacing.XS}px;
        border: none;

        > div > .ant-btn {
            padding: ${Spacing.MD}px 0 ${Spacing.MD}px ${Spacing.XS}px !important;
        }

        > .sds-card-header {
            margin: 0 ${Spacing.XS}px;
            padding: ${Spacing.SM}px ${Spacing.SM}px ${Spacing.SM}px 0;

            background: ${Colors.Gray.V50};
            border-bottom: 0;
            border-radius: ${BorderRadius.container}px;

            > div > div {
                > input {
                    ${fontFamily};
                    padding: 0;
                    line-height: ${LineHeightInPx.REGULAR}px;
                    background: ${Colors.Gray.V50};
                }
            }
        }
    }
`;
